__turbopack_context__.v({
  "active": "menu-module-sass-module__gmh7Vq__active",
  "animate": "menu-module-sass-module__gmh7Vq__animate",
  "arrow": "menu-module-sass-module__gmh7Vq__arrow",
  "betSlipActive": "menu-module-sass-module__gmh7Vq__betSlipActive",
  "betslip": "menu-module-sass-module__gmh7Vq__betslip",
  "betslipHasErrorBtn": "menu-module-sass-module__gmh7Vq__betslipHasErrorBtn",
  "bottomMenuContainer": "menu-module-sass-module__gmh7Vq__bottomMenuContainer",
  "casino": "menu-module-sass-module__gmh7Vq__casino",
  "casinoButton": "menu-module-sass-module__gmh7Vq__casinoButton",
  "casinoButtonActive": "menu-module-sass-module__gmh7Vq__casinoButtonActive",
  "closeIframe": "menu-module-sass-module__gmh7Vq__closeIframe",
  "live": "menu-module-sass-module__gmh7Vq__live",
  "liveCasino": "menu-module-sass-module__gmh7Vq__liveCasino",
  "login": "menu-module-sass-module__gmh7Vq__login",
  "menu": "menu-module-sass-module__gmh7Vq__menu",
  "menuCasinoModal": "menu-module-sass-module__gmh7Vq__menuCasinoModal",
  "navigateTo": "menu-module-sass-module__gmh7Vq__navigateTo",
  "personalDetailsVerificationModal": "menu-module-sass-module__gmh7Vq__personalDetailsVerificationModal",
  "profile": "menu-module-sass-module__gmh7Vq__profile",
  "providers": "menu-module-sass-module__gmh7Vq__providers",
  "puff-in-center": "menu-module-sass-module__gmh7Vq__puff-in-center",
  "search": "menu-module-sass-module__gmh7Vq__search",
  "slots": "menu-module-sass-module__gmh7Vq__slots",
  "spinner": "menu-module-sass-module__gmh7Vq__spinner",
  "sport": "menu-module-sass-module__gmh7Vq__sport",
  "unreadMsgsCount": "menu-module-sass-module__gmh7Vq__unreadMsgsCount",
  "userVerificationModal": "menu-module-sass-module__gmh7Vq__userVerificationModal",
  "verificationReminder": "menu-module-sass-module__gmh7Vq__verificationReminder",
});
